<template>

  <div class='more-wrap' style="position: absolute;right: 6px;top:0px;z-index: 999" :style="{width:width+'px'}">
     <div class="header">
       <div>
         操作
       </div>
       <div class="close"  @click="handleClose" >
         <i class="el-icon-close "></i>
       </div>

     </div>
    <div class="line"></div>
    <div v-for="item in getMenuList()">
      <div class="item"   @click="handleClick(item)">
        <div >{{item.name}}</div>
      </div>
      <div style="height: 4px"></div>
    </div>



  </div>

</template>

<script>
    export default {
        name: "TableMenusMore",
        props: ["menus", "row","width"],
        methods: {
            getMenuList() {
                let menus= this.menus.filter(item => {
                  if(!item.permission || item.permission.length==0){
                    return true
                  }
                    let permission = this.hasPermissionGroup(item.permission);
                    if (!permission) {
                        return false;
                    }
                    if(!item.isShow || item.isShow(this.row)){
                        return  true;
                    }
                    return  false;

                });
                return menus;

            },
            handleClick(item){
              let {params=[]}=item;
              params=[this.row,...params];
              item.click && item.click.apply(this.row,params)
            },
            handleClose(){
               this.$emit("close",null)
            }
        }
    }
</script>

<style lang="scss" scoped>
  .more-wrap{
    background: #fff;
    height:calc(100% - 0px);
    box-shadow: 0px 0px 14px 2px rgba(182,186,193,0.24);
    overflow: hidden;
  }
  .header{
    height: 45px;
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #10152D;
    padding-left: 16px;
    line-height: 45px;
    position: relative;
    .close{
      position: absolute;
      right: 20px;
      top: 0px;
      cursor: pointer;
    }

  }
   .item{
     width: calc(100% - 32px);
     height:44px;
     font-size: 16px;
     font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
     font-weight: 400;
     color: #0066FF;
     line-height: 44px;
     padding: 0px 16px ;

   }
  .item:hover{
    background-color: #F5F9FF;
    cursor: pointer;
  }
  .line{
    width: 100%;
    height: 1px;
    background-color: #D6D6DB;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableMenusMore.vue